module.exports = __webpack_public_path__ + "img/Layer-Graphics.8a03ed4e.png";